import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import RoleFormAdd from "components/Role/formAdd"
import { createRole, getAllPermissionsGrouped } from "store/role/role-action"
import { roleAction } from "store/role/role-slice"

const AddRole = () => {
  document.title = "Add Role"
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, error, groupedPermissions } = useSelector(
    state => state.role || {}
  )

  const handleSubmit = values => {
    dispatch(createRole(values, navigate))
  }

  useEffect(() => {
    dispatch(getAllPermissionsGrouped())

    return () => {
      dispatch(roleAction.resetState())
    }
  }, [dispatch])

  return (
    <RoleFormAdd
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      groupedPermissions={groupedPermissions}
    />
  )
}

export default AddRole
